var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
export class AttachedSound extends AttachedContent {
    type = 'sound';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get snd() {
        return this.trait.value;
    }
    get medFile() {
        return this.snd;
    }
    get isSndPlaying() {
        return this.context.app.media.mediaPlayer.playerPlaying.isSndPlaying(this.snd);
    }
    playNow() {
        this.context.app.media.mediaReception.playSound(this);
    }
}
__decorate([
    action.bound
], AttachedSound.prototype, "playNow", null);
